import Controller from '@ember/controller';
import CustomerModel from 'cio/models/customer';
import { isBlank } from '@ember/utils';

export default class PersonRelationshipsController extends Controller {
  declare model: CustomerModel;

  get objectsBannerTitle() {
    if (!isBlank(this.model.fullName)) {
      return `See what ${this.model.fullName} is related to`;
    }

    return 'See what your customers are related to';
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'person.relationships': PersonRelationshipsController;
  }
}
